var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M7.875 2.25v1.636h8.25V2.25h1.65v1.636h.825c.907 0 1.65.737 1.65 1.637v13.09c0 .9-.742 1.637-1.65 1.637H5.4c-.908 0-1.65-.736-1.65-1.636V5.523c0-.9.742-1.637 1.65-1.637h.825V2.25h1.65zM18.6 7.977H5.4v10.637h13.2V7.977zm-1.35 7.773v1.5h-1.5v-1.5h1.5z","transform":"translate(-16 -341) translate(0 321) translate(16 20)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }